import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
	LuxonDateAdapter,
	MAT_LUXON_DATE_FORMATS
} from "@angular/material-luxon-adapter";
import {
	MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
	MatBottomSheet,
	MatBottomSheetModule
} from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
	MatNativeDateModule
} from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { RouterModule } from "@angular/router";
import { CodetablePipe } from "@app/pipe/codetable.pipe";
import { CkDatePipe } from "@app/pipe/date.pipe";
import { FilterPipe } from "@app/pipe/filter.pipe";
import { SafeHtmlPipe } from "@app/pipe/safe-html.pipe";
import { SanitizerPipe } from "@app/pipe/sanitizer.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { DataTableModule } from "@shared/angular2-datatable/data-table.module";
import { AuctionCardComponent } from "@shared/component/auction-card/auction-card.component";
import { BannerComponent } from "@shared/component/banner/banner.component";
import { BottomSheetComponent } from "@shared/component/bottom-sheet/bottom-sheet.component";
import { DealerSearchComponent } from "@shared/component/dealer-search/dealer-search.component";
import { RatingSelectorComponent } from "@shared/component/rating-selector/rating-selector.component";
import { RoleSelectorComponent } from "@shared/component/role-selector/role-selector.component";
import { SelectComponent } from "@shared/component/select/select.component";
import { SellerSelectorComponent } from "@shared/component/seller-selector/seller-selector.component";
import { TemplateSelectorComponent } from "@shared/component/template-selector/template-selector.component";
import { VehicleSliderComponent } from "@shared/component/vehicle-slider/vehicle-slider.component";
import { ChangePartitionDialogComponent } from "@shared/dialogs/change-partition-dialog/change-partition-dialog.component";
import { ConfirmDialogComponent } from "@shared/dialogs/confirm-dialog/confirm-dialog.component";
import { CreateAuctionDialogComponent } from "@shared/dialogs/create-auction-dialog/create-auction-dialog.component";
import { DealerDacDialogComponent } from "@shared/dialogs/dealer-dac-dialog/dealer-dac-dialog.component";
import { DialogHeaderComponent } from "@shared/dialogs/dialog-header/dialog-header.component";
import { EmailDialogComponent } from "@shared/dialogs/email-dialog/email-dialog.component";
import { ExtendTimeDialogComponent } from "@shared/dialogs/extend-time-dialog/extend-time-dialog.component";
import { IncorrectVehicleDialogComponent } from "@shared/dialogs/incorrect-vehicle-dialog/incorrect-vehicle-dialog.component";
import { InformativeDialogComponent } from "@shared/dialogs/informative-dialog/informative-dialog.component";
import { NewuserDialogComponent } from "@shared/dialogs/newuser-dialog/newuser-dialog.component";
import { VehicleAuctionsDialogComponent } from "@shared/dialogs/vehicle-auctions-dialog/vehicle-auctions-dialog.component";
import { ClickOutsideDirective } from "@shared/directive/click-outside.directive";
import { DragDropDirective } from "@shared/directive/drag-drop.directive";
import { CustomHttpInterceptor } from "@shared/http.interceptor.v5";
import { StarRatingModule } from "angular-star-rating";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { CarouselModule } from "ngx-owl-carousel-o";
import { HeroComponent } from "./component/hero/hero.component";

// @ts-ignore
@NgModule({
	declarations: [
		BannerComponent,
		DealerSearchComponent,
		RoleSelectorComponent,
		DragDropDirective,
		ClickOutsideDirective,
		SelectComponent,
		NewuserDialogComponent,
		FilterPipe,
		CkDatePipe,
		SafeHtmlPipe,
		CodetablePipe,
		TemplateSelectorComponent,
		EmailDialogComponent,
		RatingSelectorComponent,
		ChangePartitionDialogComponent,
		SellerSelectorComponent,
		ConfirmDialogComponent,
		DealerDacDialogComponent,
		CreateAuctionDialogComponent,
		VehicleAuctionsDialogComponent,
		ExtendTimeDialogComponent,
		IncorrectVehicleDialogComponent,
		SanitizerPipe,
		InformativeDialogComponent,
		AuctionCardComponent
	],
	imports: [
		CarouselModule,
		MatSliderModule,
		RouterModule,
		MatStepperModule,
		StarRatingModule.forRoot(),
		DataTableModule,
		NgxSliderModule,
		CollapseModule,
		BsDropdownModule,
		BsDatepickerModule,
		TimepickerModule,
		MatMenuModule,
		MatNativeDateModule,
		MatDatepickerModule,
		MatDialogModule,
		MatBottomSheetModule,
		ReactiveFormsModule,
		FormsModule,
		CommonModule,
		TranslateModule,
		MatTableModule,
		MatPaginatorModule,
		MatFormFieldModule,
		MatSortModule,
		MatInputModule,
		MatSlideToggleModule,
		MatButtonModule,
		MatCheckboxModule,
		MatRadioModule,
		MatSelectModule,
		MatIconModule,
		MatListModule,
		MatCardModule,
		MatExpansionModule,
		MatChipsModule,
		StarRatingModule,
		VehicleSliderComponent,
		HeroComponent,
		BottomSheetComponent,
		DialogHeaderComponent
	],
	exports: [
		CarouselModule,
		SanitizerPipe,
		FilterPipe,
		MatStepperModule,
		StarRatingModule,
		CodetablePipe,
		SafeHtmlPipe,
		CkDatePipe,
		DataTableModule,
		NewuserDialogComponent,
		SelectComponent,
		NgxSliderModule,
		CollapseModule,
		TimepickerModule,
		BsDatepickerModule,
		MatMenuModule,
		MatSliderModule,
		DealerSearchComponent,
		MatNativeDateModule,
		MatDatepickerModule,
		MatBottomSheetModule,
		TemplateSelectorComponent,
		ReactiveFormsModule,
		TranslateModule,
		FormsModule,
		MatTableModule,
		MatPaginatorModule,
		MatFormFieldModule,
		MatSortModule,
		MatInputModule,
		MatSlideToggleModule,
		MatButtonModule,
		MatCheckboxModule,
		MatRadioModule,
		MatSelectModule,
		MatIconModule,
		MatListModule,
		MatCardModule,
		MatExpansionModule,
		BannerComponent,
		MatChipsModule,
		DragDropDirective,
		ClickOutsideDirective,
		BottomSheetComponent,
		HeroComponent,
		AuctionCardComponent
	],
	providers: [
		MatNativeDateModule,
		{ provide: MatBottomSheet, useValue: {} },
		{
			provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
			useValue: { hasBackdrop: false }
		},
		{ provide: MAT_DATE_LOCALE, useValue: "it-IT" },
		{
			provide: DateAdapter,
			useClass: LuxonDateAdapter,
			deps: [MAT_DATE_LOCALE]
		},
		{ provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CustomHttpInterceptor,
			multi: true
		},
	]
})
export class SharedModule { }